<template>
  <TurnsList/>
</template>
<script>
import TurnsList from '@/components/modules/admin/turns/list'
export default {
  name: 'turns',
  components: {
    TurnsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/turns/list.vue